var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlus = function SvgPlus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.75 3.515a.75.75 0 0 0-1.5 0v7.735H3.515a.75.75 0 0 0 0 1.5h7.735v7.735a.75.75 0 0 0 1.5 0V12.75h7.735a.75.75 0 0 0 0-1.5H12.75V3.515Z"
  })));
};
export default SvgPlus;